import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import "swiper/css";
import './App.css';
import "animate.css/animate.min.css";
import './custom.css';
import "./style.css";
import './customResponisve.css'
import "./responsive.css"
import NavRouter from './router/NavRouter';
import { useEffect, useState } from 'react';
import { BaseUrl } from './helper/BaseUrl';
import SEO from "./helper/SEO";
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ModalProvider } from './contexts/ModalContext';

function App({ initialData, initialSeo, initialGlobalSchema }) {
  const [seoData, setSeoData] = useState(null);
  const [globalSchema, setGlobalSchema] = useState(initialGlobalSchema || null);
  const location = useLocation();

  const getSeoUrl = (pathname) => {
    const path = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
    return `${BaseUrl}api/seo-by-url${path}`;
  };

  // APi
  const Detailfetcher = async () => {
    try {
      const response = await fetch(getSeoUrl(location.pathname), {
        method: 'GET',
      });
      const result = await response.json();
      if (result.seo === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setSeoData(result.seo);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    Detailfetcher();
  }, [location.pathname])

  useEffect(() => {
    const controller = new AbortController();

    const fetchGlobalSchema = async () => {
      try {
        const response = await fetch(`${BaseUrl}api/global-seo`, {
          method: 'GET',
          signal: controller.signal,
        });
        const result = await response.json();
        setGlobalSchema(result.schema);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error('Schema fetch error:', error.message);
        }
      }
    };

    fetchGlobalSchema();
    return () => controller.abort();
  }, []);


  // Source Url
  useEffect(() => {
    if (typeof window !== "undefined") {
      const existingSource = sessionStorage.getItem("source_url");
      if (!existingSource) {
        const landingUrl = window.location.href;
        sessionStorage.setItem("source_url", landingUrl);
      }
    }
  }, []);


  return (

    <>
      <div className="App">
        <SEO seoData={seoData} initialSeo={initialSeo} globalSchema={globalSchema} />
        <ModalProvider>
          <NavRouter initialData={initialData} />
        </ModalProvider>
        <ToastContainer />
      </div>
    </>

  );
}

export default App;
